export const NANO_DOLLARS_PER_DOLLAR = 1_000_000_000

export const roundPrice = (price: number) => Math.ceil(price * 100) / 100

export const toOptionalFixed = (num: number, digits: number) => {
  return Number.parseFloat(num.toFixed(digits))
}

export const formatters = {
  // Takes in a number of bytes as input and returns a human-readable string (in SI system), e.g.
  // - 1000 bytes => 1 kB
  // - 1000000 bytes => 1 MB
  // - 1000000000 bytes => 1 GB
  byte(value: number, digits = 1) {
    const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB']
    const unitIndex = value ? Math.floor(Math.log(value) / Math.log(1000)) : 0
    const unit = units[unitIndex]
    const unitValue = value / 1000 ** unitIndex

    return `${Intl.NumberFormat('en').format(toOptionalFixed(unitValue, digits))} ${unit}`
  },
  number(value: number, digits = 1) {
    return Intl.NumberFormat('en', { notation: 'compact' }).format(toOptionalFixed(value, digits))
  },
  dollars(value: number, digits = 2) {
    return value.toFixed(digits)
  },
  $dollars(value: number, digits = 2) {
    return `$${Intl.NumberFormat('en', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value)}`
  },
  centdollars(value: number, digits = 2) {
    return (value / 100).toFixed(digits)
  },
  $centdollars(value: number, digits = 2) {
    return `$${Intl.NumberFormat('en', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value / 100)}`
  },
  nanodollars(value: number, digits = 2) {
    return roundPrice(value / NANO_DOLLARS_PER_DOLLAR).toFixed(digits)
  },
  $nanodollars(value: number, digits = 2) {
    return `$${Intl.NumberFormat('en', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(roundPrice(value / NANO_DOLLARS_PER_DOLLAR))}`
  },
  numberDefault(value: number, digits = 1) {
    return Intl.NumberFormat('en').format(toOptionalFixed(value, digits))
  },
  numberLocale(value: number, digits = 1, locale = 'en') {
    return Intl.NumberFormat(locale).format(toOptionalFixed(value, digits))
  },
  percent(value: number) {
    return `${value * 100}%`
  },
}

export function baseToNano(base: number): number {
  return base * 1_000_000_000
}
